import React, {useState, useEffect} from 'react'
import { Link, useNavigate } from "react-router-dom"
import API from "../../api/base_url";
import Moment from 'react-moment';



const HeaderDashboard = ({success, func, data}) => {
  const history = useNavigate();
  const [displayName, setDisplayName] = useState("") 
  const [displayPhoto, setDisplayPhoto] = useState("") 

  
    let token = localStorage.token;
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    useEffect(() => {
      API.get("dashboard/account/profile", { headers })
      .then(({ data:content }) => {
        setDisplayName(content.data.name)
        setDisplayPhoto(content.data.photo)
      })
      .catch((err) => {
        console.log(err);
      });
    }, []);

  const logout = () => {
    localStorage.removeItem('token')
      history('/');
  }
  return (
    <nav className="navbar navbar-top  navbar-expand navbar-dark bg-primary mb-1  " >
      <div className="container-fluid">
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          {/* Search form */}
          <ul className={success ? "text-success  font-weight-bold  fontTV d-none d-md-block " : "d-none d-md-block text-light font-weight-bold fontTV"}>
            <li>
              <Moment format='DD-MM-YYYY, HH:mm:ss' /> 
            </li>
          </ul>
          {/* Navbar links */}
          <ul className="navbar-nav mt-0 align-items-center ml-md-auto p-2" data-action="sidenav-pin" data-target="#sidenav-main">
            <li className="nav-item d-xl-none">
              {/* Sidenav toggler */}
              <div className="pr-3 sidenav-toggler sidenav-toggler-dark" data-action="sidenav-pin" data-target="#sidenav-main">
                <div className="sidenav-toggler-inner">
                  <i className="sidenav-toggler-line" />
                  <i className="sidenav-toggler-line" />
                  <i className="sidenav-toggler-line" />
                </div>
              </div>
            </li>
          </ul>

          <div className={success ? "text-success font-weight-bold   d-md-none" : "  text-light font-weight-bold d-md-none"}>
              <Moment format='DD-MM-YYYY, HH:mm:ss' /> 
          </div>
          
          <ul className="navbar-nav align-items-center ml-auto ml-md-0 mt--1">
            <li className="nav-item dropdown">
              <a className="nav-link pr-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <div className="media align-items-center">
                  <span className="avatar avatar-xs rounded-circle">
                    <img alt="i" src={displayPhoto} />
                  </span>
                  <div className="media-body ml-2 d-none d-lg-block">
                    <span className="mb-0 text-xs text-white font-weight-bold ">{displayName}</span>
                  </div>
                </div>
              </a>
              <div className="dropdown-menu dropdown-menu-right">
                <Link to="/account/myProfile" className="dropdown-item">
                  <i className="ni ni-single-02" />
                  <span>My profile</span>
                </Link>
                <div className="dropdown-divider" />
                <a onClick={()=> logout()} className="dropdown-item">
                  <i className="ni ni-user-run" />
                  <span>Logout</span>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}

export default HeaderDashboard